// extracted by mini-css-extract-plugin
export default {"wrapper":"pq-z","response":"qq-z","error":"rq-z","disabled":"sq-z","buttons":"tq-z","feedbackQuestionSection":"uq-z","yesNoWrapper":"vq-z"};